import React, { useState } from "react";
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  Button,
  Container,
} from "reactstrap";
import logoWhite from "../assets/img/boxs_logo_new_white.png";

const AppNavBar = ({ fullWidth }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen((open) => !open);

  return (
    <Navbar
      expand="lg"
      dark
      style={{
        position: "fixed",
        top: 0,
        width: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: 1000,
      }}
    >
      <Container
        className={`d-flex justify-content-between align-items-center ${
          fullWidth && "w-100 mw-100 px-4"
        }`}
      >
        <NavbarBrand href="/">
          <img src={logoWhite} alt="Boxs logo" height="30" />
        </NavbarBrand>

        {/* Hamburger toggler */}
        <NavbarToggler onClick={toggle} className="d-lg-none" />

        {/* Full‑width overlay menu */}
        {isOpen && (
          <div className="d-lg-none position-absolute top-100 start-0 w-100 bg-dark bg-opacity-75 rounded-bottom p-3">
            <Nav navbar className="d-flex flex-column align-items-end">
              <NavItem>
                <NavLink
                  href="/catalog-collection"
                  className="text-light text-end"
                >
                  Catalog
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="/sample-orders"
                  className="text-light text-end"
                >
                  Sample Orders
                </NavLink>
              </NavItem>
              <NavItem className="mt-2">
                <NavLink href="home#faq" className="text-light text-end">
                  FAQ
                </NavLink>
              </NavItem>
              <NavItem className="mt-3">
                <NavLink href="/login_with_otp" className="p-0">
                  <Button outline color="light" size="sm">
                    Login
                  </Button>
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        )}
        <Nav
          navbar
          className="d-none d-lg-flex align-items-center ms-auto fs-13px"
        >
          <NavItem>
            <NavLink href="/catalog-collection" className="text-light">
              Catalog
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="/sample-orders" className="text-light">
              Sample Orders
            </NavLink>
          </NavItem>
          <NavItem className="ms-3">
            <NavLink href="home#faq" className="text-light">
              FAQ
            </NavLink>
          </NavItem>
          <NavItem className="ms-4">
            <NavLink href="/login_with_otp" className="p-0">
              <Button className="fs-13px" outline color="light">
                Login
              </Button>
            </NavLink>
          </NavItem>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default AppNavBar;
